import React, { ButtonHTMLAttributes, FC } from 'react'
import styled from 'styled-components'

import { useTranslation } from 'helpers/hooks/useTranslation'
import { Icon, IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import { darkGrayColor } from 'uiComponents/constants/colors'
import {
  fontFamilyPrimary,
  fsXS,
  fwMediumBold,
} from 'uiComponents/constants/typography'

const ToggleIcon = styled(Icon)`
  display: block;
  opacity: 0.275;
  margin: 2px 0 0 6px;
  z-index: 1;
  transition: 0.15s;
`

const ToggleLabel = styled.span`
  position: relative;
  z-index: 0;
`

const ToggleWrapper = styled.button`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${fontFamilyPrimary};
  color: ${darkGrayColor};
  font-size: ${fsXS}px;
  line-height: 18px;
  font-weight: ${fwMediumBold};
  border: none;
  background-color: none;
  transition: 0.15s;

  &:focus {
    outline: 0;
  }

  &:hover {
    cursor: pointer;
    color: #777;

    ${ToggleIcon} {
      opacity: 0.4;
    }
  }
`

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  collapseLabel?: string
  expanded?: boolean
  expandLabel?: string
}

const ExpandButton: FC<Props> = props => {
  const { t } = useTranslation()
  const {
    collapseLabel = t('Weniger Kategorien'),
    expanded,
    expandLabel = t('Mehr Kategorien'),
  } = props

  return (
    <ToggleWrapper data-testid="MoreButton" {...props}>
      <ToggleLabel data-testid="ToggleLabel">
        {expanded ? collapseLabel : expandLabel}
      </ToggleLabel>
      <ToggleIcon
        size={IconSize.XS}
        asset={IconName[expanded ? 'IcChevronUp' : 'IcChevronDown']}
      />
    </ToggleWrapper>
  )
}

export default ExpandButton
